// extracted by mini-css-extract-plugin
export var form = "_52-0";